/** Durable web state — wait for Connector disk seed (#1110). */
import { isConnectorAvailable } from './connector';

export const WEB_STATE_SEED_EVENT = 'maestro-web-state-seed-ready';

export type WebStateSeedDetail = { keys_restored?: number; keys_skipped?: number };

type TauriCore = { invoke: (cmd: string, args?: unknown) => Promise<unknown> };

function getTauriInvoke(): TauriCore['invoke'] | undefined {
  return (window as Window & { __TAURI__?: { core?: TauriCore } }).__TAURI__?.core?.invoke;
}

export async function waitForDurableWebStateSeed(timeoutMs: number): Promise<void> {
  if (typeof window === 'undefined') return;
  if (!isConnectorAvailable()) return;
  const w = window as Window & { __MAESTRO_WEB_STATE_SEED__?: WebStateSeedDetail };
  if (w.__MAESTRO_WEB_STATE_SEED__) return;
  const invoke = getTauriInvoke();
  if (invoke) {
    try {
      const entries = await invoke('get_web_state_entries') as Record<string, string>;
      if (!entries || Object.keys(entries).length === 0) return;
      if (w.__MAESTRO_WEB_STATE_SEED__) return;
    } catch {
      return;
    }
  }
  return new Promise((resolve) => {
    const timer = setTimeout(resolve, timeoutMs);
    window.addEventListener(WEB_STATE_SEED_EVENT, () => { clearTimeout(timer); resolve(); }, { once: true });
  });
}
